import { track } from "@opensea/analytics"
import { useChains } from "@opensea/app-kit"
import { useAccount } from "@opensea/wallet"
import { setContext } from "@sentry/nextjs"
import Cookies from "js-cookie"
import { useEffect } from "react"
import { useAccount as useWagmiAccount } from "wagmi"
import { useIsWagmiStateTrackingEnabled } from "@/hooks/use-flags"
import { useFlowTracking } from "./use-flow-tracking"
import { useSwitchChainTracking } from "./use-switch-chain-tracking"
import { useWalletTracking } from "./use-wallet-tracking"

export function WalletAnalyticsHandler() {
  useWalletTracking()
  useFlowTracking()
  useSwitchChainTracking()
  const { chains } = useChains()

  const { address, chainId, connectorId, isConnecting, authenticated, ready } =
    useAccount()
  useEffect(() => {
    setContext("wallet", {
      address,
      chainId,
      connectorId,
      isConnecting,
      authenticated,
      ready,
    })
    setContext("appChains", { chains: chains.map(chain => chain.name) })
  }, [
    address,
    chainId,
    connectorId,
    isConnecting,
    authenticated,
    ready,
    chains,
  ])

  const wagmiAccount = useWagmiAccount()
  const trackWagmiState = useIsWagmiStateTrackingEnabled()
  useEffect(() => {
    const wagmiData = {
      address: wagmiAccount.address,
      chainId: wagmiAccount.chainId,
      connectorId: wagmiAccount.connector?.id,
      isConnecting: wagmiAccount.isConnecting,
      isReconnecting: wagmiAccount.isReconnecting,
      isDisconnected: wagmiAccount.isDisconnected,
      isConnected: wagmiAccount.isConnected,
      status: wagmiAccount.status,
    }
    if (trackWagmiState) {
      void track("Wagmi Account", wagmiData)
    }
    setContext("wagmi", wagmiData)
  }, [trackWagmiState, wagmiAccount])

  useEffect(() => {
    Cookies.set("os2AccessEx", "Wdr6yywSUvHzIWYeBybn17MOdxKRbbhM", {
      path: "/",
      domain: "opensea.io",
      sameSite: "lax",
      secure: true,
      expires: 365,
    })
  }, [])

  return null
}
